var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NodeViewWrapper',{staticClass:"preview",attrs:{"data-text-el":"preview","as":"div","contenteditable":"false"}},[_c('NodeViewContent'),_vm._v(" "),_c('NcReferenceList',{attrs:{"text":_vm.node.attrs.href,"limit":1,"interactive":!_vm.extension.options.isEmbedded,"display-fallback":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }